import RoutePalette from './RoutePalette'

export default RoutePalette